<template>
  <b-tabs
    v-model="tabIndex"
    @input="emitActiveTab"
    active-nav-item-class="danger"
    active-tab-class="font-weight-bold text-success"
  >
    <b-tab
      :active="tabIndex === 0"
      title="Active Companies"
      data-cy="active-companies-tab"
    >
      <slot v-if="tabIndex === 0"></slot>
    </b-tab>

    <b-tab
      :active="tabIndex === 1"
      title="Archived Companies"
      data-cy="archived-companies-tab"
    >
      <slot v-if="tabIndex === 1"></slot>
    </b-tab>
  </b-tabs>
</template>

<script>
export default {
  data() {
    return { tabIndex: 0 };
  },

  computed: {
    showActiveTab() {
      return this.tabIndex === 0;
    }
  },

  methods: {
    emitActiveTab(index) {
      this.tabIndex = index;
      const tab = index ? "archived" : "active";
      this.$emit("change-tab", tab);
    }
  }
};
</script>

<style>
</style>